<template>
  <div id="GoTop" @click="GoTop()">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div>
</template>
<script>
export default {
  name: 'GoTop',
  data() {
    return {
      flag: false,
    }
  },
  methods: {
    GoTop() {
      ;(function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll)
          window.scrollTo(0, currentScroll - currentScroll / 10)
        }
      })()
    },
  },
}
</script>
<style scoped>
#GoTop {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99999999;
  cursor: pointer;
}
#GoTop > span {
  display: block;
  padding: 10px;
  color: rgb(255, 255, 255);
  font-size: 30px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue